import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ICONS, unit } from '@hcr/ui'

import { COLORS } from '../../../../../../libs/ui/src/lib/constants'
import { ButtonBuyAccommodation } from '../button-buy-accommodation'

import type { OwnerBuyAccommodationDrawerMode } from './OwnerBuyAccomodationDrawerMode'

interface OwnerBuyAccommodationProps {
  onClose: () => void
  setMode: (
    value:
      | ((prevState: OwnerBuyAccommodationDrawerMode) => OwnerBuyAccommodationDrawerMode)
      | OwnerBuyAccommodationDrawerMode
  ) => void
}

export const OwnerBuyAccommodation: FC<OwnerBuyAccommodationProps> = ({ onClose, setMode }) => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Stack paddingBottom={unit(4)} alignItems='center' flexDirection='row' justifyContent='space-between'>
        <Box sx={{ width: unit(8.5) }}></Box>
        <Typography variant='uppercaseS'>{t('home.owner-buy-accommodation.title')}</Typography>
        <IconButton onClick={onClose} aria-label={t('home.close')} sx={{ alignSelf: 'center', padding: unit(3) }}>
          <FontAwesomeIcon size={'sm'} icon={ICONS.farXmark} />
        </IconButton>
      </Stack>
      <Stack flexDirection='column' gap={unit(2.5)}>
        <Stack
          border={`${unit(0.25)} solid ${COLORS.vaalea[400]}`}
          paddingY={unit(4.5)}
          paddingLeft={unit(4)}
          paddingRight={unit(6)}
        >
          <Typography variant='headlineM' marginBottom={unit(1.5)}>
            Holidayclub.fi
          </Typography>
          <Typography variant='bodyM' marginBottom={unit(5.5)}>
            {t('home.owner-buy-accommodation.description')}
          </Typography>
          <ButtonBuyAccommodation isDrawerOpen={true} variant='outlined' color='inherit'>
            {t('home.owner-buy-accommodation.cta')}
          </ButtonBuyAccommodation>
        </Stack>

        {/*  TODO SII-400: Below part is temporarily commented because of lack of API. */}
        {/*  <Stack*/}
        {/*    border={`1px solid ${COLORS.vaalea[400]}`}*/}
        {/*    paddingY={unit(4.5)}*/}
        {/*    paddingLeft={unit(4)}*/}
        {/*    paddingRight={unit(6)}*/}
        {/*  >*/}
        {/*    <Typography variant='headlineM' marginBottom={unit(1.5)}>*/}
        {/*      {t('home.holiday-points.title')}*/}
        {/*    </Typography>*/}
        {/*    <Typography variant='bodyM' marginBottom={unit(5.5)}>*/}
        {/*      {t('home.holiday-points.description', { availablePoints: '1490000', earlierAvailablePoints: '77000' })}*/}
        {/*    </Typography>*/}
        {/*    <ButtonBuyAccommodation isDrawerOpen={true} variant='outlined' color='inherit' sx={{ marginBottom: '22px' }}>*/}
        {/*      {t('home.holiday-points.cta')}*/}
        {/*    </ButtonBuyAccommodation>*/}
        {/*    <Stack*/}
        {/*      paddingY={unit(4.5)}*/}
        {/*      paddingLeft={unit(4)}*/}
        {/*      paddingRight={unit(6)}*/}
        {/*      sx={{ backgroundColor: COLORS.vaalea['60%'] }}*/}
        {/*    >*/}
        {/*      <Stack flexDirection='row' justifyContent='space-between' alignItems='center' marginBottom={unit(1.5)}>*/}
        {/*        <Typography variant='labelM'>RCI:n kautta ulkomaille</Typography>*/}
        {/*        <FontAwesomeIcon icon={ICONS.falGlobe} color={COLORS.burgundi[500]} fontSize={'22px'} />*/}
        {/*      </Stack>*/}
        {/*      <Typography variant='bodyM' marginBottom={unit(2)}>*/}
        {/*        Yli 4000 RCI lomakeskusta ympäri maailman.*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        component='a'*/}
        {/*        target={'target'}*/}
        {/*        rel={'rel'}*/}
        {/*        onClick={() => setMode(OwnerBuyAccommodationDrawerMode.INTERNATIONAL_DESTINATION)}*/}
        {/*        onKeyDown={(e: KeyboardEvent) => {*/}
        {/*          if (e.key === 'Enter' || e.key === ' ') {*/}
        {/*            setMode(OwnerBuyAccommodationDrawerMode.INTERNATIONAL_DESTINATION)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*        role='link'*/}
        {/*        tabIndex={0}*/}
        {/*        variant='textLinkM'*/}
        {/*        color={COLORS.burgundi[500]}*/}
        {/*      >*/}
        {/*        {t('home.book-an-international-holiday-using-points')}*/}
        {/*      </Typography>*/}
        {/*    </Stack>*/}
        {/*  </Stack>*/}
      </Stack>
    </Stack>
  )
}
